import React, { Component } from 'react';
import EventBus from '../service/eventbus';
import { isAuthenticated, getHomePage, getEnrollStudyItems, deleteEnrollStudyItem } from '../service/service';
import { Table, Button, Spinner, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

export class Home extends Component {
    static displayName = Home.name;

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            authorized: false,
            enrollItems: [],
            homepage: '',
            showDeleteModal: false,
            showDeleteStatus: false,
            deletingItem: null,
            deleteStatus: null,
        };

        this.reloadContent = this.reloadContent.bind(this);
    }

    async componentDidMount() {
        document.title = 'הרשמה לקורסים';

        EventBus.on('studyYearChanged', this.reloadContent);
        await this.reloadContent();
    }

    async componentWillUnmount() {
        EventBus.off('studyYearChanged', this.reloadContent);
    }

    async reloadContent() {
        console.log('reloading home content');

        var auth = await isAuthenticated();
        var hpage = '';
        var eitems = '';

        if (auth !== false) {
            hpage = await getHomePage();
            eitems = await getEnrollStudyItems();
        }

        //console.log('setting home state');
        this.setState({ authorized: auth !== false, homepage: hpage, enrollItems: eitems, loading: false });
    }

    ssoSignIn() {
        var contextId = Math.random() * 100000000;
        var url = window.location.origin + '/signin/ssosignin/?p=';
        window.location.href = 'https://timetable.shahaf.info/ShfSignIn.aspx?sid=webapp&cid=' + contextId + '&r=' + url;
        //window.location.href = url + "eyJOYW1lIjoi15XXnNeT15nXnteZ16gg16fXqNeh16DXldeRIiwiVHoiOiIzMTAyOTUyMjUiLCJUb2tlbiI6IlFrTWJmV2NHQUFZaWZCZ0RKdzRWZjFzL0VRWjJBVU1OZVFwQkFDY0JDaUpoREZzTlMwTTVTR0lHRzJRZ1lXQlEiLCJTdHVkZW50Ijoibm8iLCJTY2hvb2xzIjpbXX0=";
    }

    getStatus(code) {
        if (code === 11)
            return "ברשימת המתנה";
        else if (code === 12)
            return "נרשם"
        else if (code === 13)
            return "הרשמה בוטלה"
        else if (code === 14)
            return "מאושר"
        else if (code === 15)
            return "נדחה"

        return "";
    }

    async deleteEnroll(item) {
        //console.log('deleting');
        this.setState({ showDeleteModal: true, deletingItem: item });
    }

    async deleteModelAction(ac) {
        if (ac === true) {
            if (this.state.deletingItem) {
                var status = await deleteEnrollStudyItem(this.state.deletingItem.id);
                var eitems = await getEnrollStudyItems();
                this.setState({ showDeleteModal: false, showDeleteStatus: true, deletingItem: null, deleteStatus: status, enrollItems: eitems });
            }
            else {
                this.setState({ showDeleteModal: false, deletingItem: null });
            }
        }
        else {
            this.setState({ showDeleteModal: false, deletingItem: null });
        }
    }

    async deleteModelStatusHide() {
        this.setState({ showDeleteModal: false, showDeleteStatus: false, deletingItem: null, deleteStatus: null });
    }

    render() {
        return (
            <div>
                { this.state.authorized === false && this.state.loading === false &&
                    <div>
                        <h1>ברוכים הבאים לאתר הרשמה</h1>
                        <p>אנא בצעו כניסה למערכת</p>
                        <button className="btn btn-primary" onClick={this.ssoSignIn}>כניסה למערכת</button>
                    </div>
                }
                { this.state.authorized &&
                    <div>
                        <h1><section dangerouslySetInnerHTML={{ __html: this.state.homepage.title }} /></h1>
                        <section dangerouslySetInnerHTML={{ __html: this.state.homepage.mainnote }} />
                        <hr/>
                        {this.state.enrollItems &&
                        <div>
                        {(this.state.enrollItems == null || this.state.enrollItems.length === 0) &&
                            <div>
                                <div>אינך רשומ/ה לאף קורס</div>
                                <br/>
                                <Button
                                    color="primary"
                                    size="sm"
                                    onClick={() => this.props.history.push('/enroll')}>
                                    הרשמה
                                </Button>
                            </div>
                        }
                        {this.state.enrollItems && this.state.enrollItems.length > 0 &&
                            <div>הינך רשומ/ה לקורסים הבאים</div>
                        }
                        <Table>
                            <tbody>
                            {this.state.enrollItems && this.state.enrollItems.map(si =>
                                <tr key={si.id}>
                                    <td>{si.name}</td>
                                    <td>{this.getStatus(si.status)}</td>
                                    <td style={{ textAlign: "left" }}>
                                        <Button outline
                                            color="primary"
                                            size="sm"
                                            onClick={() => this.deleteEnroll(si)}>
                                            בטל הרשמה
                                        </Button>
                                    </td>
                                </tr>
                            )}
                            </tbody>
                        </Table>
                        <Modal isOpen={this.state.showDeleteModal} style={{direction: 'rtl', textAlign: 'right'}}>
                            <ModalHeader toggle={this.toggle}>ביטול הרשמה</ModalHeader>
                            <ModalBody>
                                <div>
                                    האם ברצונך לבטל הרשמה לקורס  ?
                                </div>
                            </ModalBody>
                            <ModalFooter>
                                <Button color="danger" onClick={() => this.deleteModelAction(true)}>בטל הרשמה</Button>{' '}
                                <Button color="secondary" onClick={() => this.deleteModelAction(false)}>לא לבטל הרשמה</Button>
                            </ModalFooter>
                        </Modal>
                        <Modal isOpen={this.state.showDeleteStatus} style={{ direction: 'rtl', textAlign: 'right' }}>
                            <ModalHeader>ביטול הרשמה</ModalHeader>
                            <ModalBody>
                                {this.state.deleteStatus && this.state.deleteStatus.status === 'FAIL' &&
                                    <div>
                                        ביטול הרשמה נכשל, אנא נסו שוב
                                    </div>
                                }
                                {this.state.deleteStatus && this.state.deleteStatus.status === 'SUCCESS' &&
                                    <div>
                                        ביטול הרשמה בוצע בהצלחה
                                    </div>
                                }
                            </ModalBody>
                            <ModalFooter>
                                <Button color="primary" onClick={() => this.deleteModelStatusHide()}>המשך</Button>{' '}
                            </ModalFooter>
                        </Modal>
                        </div>
                        }
                    </div>
                }
            </div>
        );
    }
}
